// 输入框里的「深入研究」和回答下面的「展开研究」：按当前范围（问题里说了在哪儿找就缩小）开一次研究，换到研究页。

import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App as AntApp } from 'antd'
import { createResearch } from '../../api/research'
import { useAllScopeKbs } from '../chat/Composer'
import { scopeToRequest, type Scope } from '../chat/prefs'
import { useQuestionRouter } from '../chat/useRoute'

export function useResearchMode() {
  const navigate = useNavigate()
  const qc = useQueryClient()
  const { message } = AntApp.useApp()
  const allIds = (useAllScopeKbs() ?? []).map((k) => k.id)
  const route = useQuestionRouter()
  const [on, setOn] = useState(false)

  const start = useMutation({
    mutationFn: async ({ question, scope }: { question: string; scope: Scope }) => {
      // 「不查资料」也要查：按全部知识库
      const s: Scope = scope.kind === 'none' ? { kind: 'all' } : scope
      const req = scopeToRequest(s, allIds)
      const routed = s.kind === 'all' || s.kind === 'kb' ? await route(question, req.knowledgeBaseIds) : null
      return createResearch({
        question,
        ...(routed ? { knowledgeBaseIds: routed.knowledgeBaseIds, knowledgeIds: routed.knowledgeIds, label: routed.label } : req),
        ...(s.kind === 'doc' ? { label: `只查《${s.title}》` } : {}),
      })
    },
    onSuccess: (r) => {
      qc.invalidateQueries({ queryKey: ['research'] })
      setOn(false)
      navigate(`/research/${r.id}`)
    },
    onError: (e) => void message.error(e.message),
  })

  return {
    on,
    onToggle: setOn,
    starting: start.isPending,
    start: (question: string, scope: Scope) => start.mutate({ question, scope }),
  }
}
